module.exports = __webpack_public_path__ + "static/media/files-placeholder.1ab91db9.svg";